module.exports = __webpack_public_path__ + "media/images/teaser-action-map-marker-3-afae9c4cdc3464085843c60d70a52c2e.svg";